import InmuebleUserTemplate from "../../components/templates/usuario/InmuebleUserTemplate"

const InmuebleUser = () => {
    return <InmuebleUserTemplate/>;
};

export default InmuebleUser;